import React, {ReactNode} from 'react'
import styled from 'styled-components'

import ErrorState from './error-state'
import PageComponent from './page-component'
const ErrorLayout = styled.div({ margin: 'auto', maxWidth: '1200px' })

interface ErrorBoundaryState {
  hasError: boolean;
  error:any
}

interface ErrorBoundaryProps {
  children: ReactNode;
}

// class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {


class GlobalErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState>  {
  // state: { hasError: boolean; error?: Error } = { hasError: false }
 constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error: Error /* , errorInfo: any */) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo)
    // if(error)
    this.setState({ error: error })
  }

  render() {
    if (this.state.hasError) {
      return (
        <PageComponent>
          <ErrorLayout>
            <ErrorState error={this.state.error} />
          </ErrorLayout>
        </PageComponent>
      )
    }

    return this.props?.children ? this.props.children: null
  }
}
export default GlobalErrorBoundary
